import React, { useState } from 'react';
import './navbar.css'
import logo from '../../asset/logo.png'
import contactImg from '../../asset/contact.png';
import {Link} from 'react-scroll';
import menu from '../../asset/menu.png';
 
const Navbar = () => {
  const [showMenu,setShowMenu]=useState(false);
  return (
    <nav className='navbar'
    data-aos="fade-down"
    data-aos-duration="1000"
    >
      <img src={logo} alt='Logo' className='logo'/>
      <div className='desktopMenu'>
        <Link activeClass='active' to='info' spy={true} smooth={true} offset={-100} duration={500} className='desktopMenuListItem'>Home</Link>
        <Link activeClass='active' to='AboutMe' spy={true} smooth={true} offset={5} duration={500} className='desktopMenuListItem'>About</Link>
        <Link activeClass='active' to='experience' spy={true} smooth={true} offset={-80} duration={500} className='desktopMenuListItem'>experience</Link>
        <Link activeClass='active' to='projects' spy={true} smooth={true} offset={-30} duration={500} className='desktopMenuListItem'>Project</Link>
      </div>
      {/* <button className='desktopMenuBtn' offset={-220} onClick={()=>{
        document.getElementById('contact').scrollIntoView({behavior:'smooth'});
      }}>
        <img src={contactImg} alt=''  className='desktopMenuImg'/>Contact Me
      </button> */}
      <button
  className="desktopMenuBtn"
  onClick={() => {
    const element = document.getElementById('contact');
    const offset = -100; // Adjust this to your desired offset
    const elementPosition = element.getBoundingClientRect().top; // Get element position relative to viewport
    const offsetPosition = elementPosition + window.pageYOffset + offset; // Add the offset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth', // Smooth scrolling effect
    });
  }}
>
  <img src={contactImg} alt="" className="desktopMenuImg" />
  Contact Me
</button>

      <img src={menu} alt='menu' className='mobMenu' onClick={()=>setShowMenu(!showMenu)}/>
      <div className='navMenu' style={{display:showMenu?'flex':'none'}}>
        <Link activeClass='active' to='info' spy={true} smooth={true} offset={-100} duration={500} className='ListItem' onClick={()=>setShowMenu(false)}>Home</Link>
        <Link activeClass='active' to='AboutMe' spy={true} smooth={true} offset={5} duration={500} className='ListItem' onClick={()=>setShowMenu(false)}>About</Link>
        <Link activeClass='active' to='experience' spy={true} smooth={true} offset={-80} duration={500} className='ListItem' onClick={()=>setShowMenu(false)}>Experience</Link>
        <Link activeClass='active' to='projects' spy={true} smooth={true} offset={-30} duration={500} className='ListItem' onClick={()=>setShowMenu(false)}>Project</Link>
        <Link activeClass='active' to='contactPage' spy={true} smooth={true} offset={-100} duration={500} className='ListItem' onClick={()=>setShowMenu(false)}>Contact</Link>
      </div>
    </nav>
  )
}


export default Navbar;
